import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import css from './Modal.module.scss';
import X02 from "../Icons/X02.jsx";
import {colors} from "../../utils/colors.js";

const Modal = ({isOpen, onClose, children, title, className, style}) => {
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className={`${css.modalOverlay} ${className}`} onClick={onClose}>
      <div className={css.modalContent} style={style} onClick={e => e.stopPropagation()}>
        <div className={css.modalHeader}>
          <h3>{title}</h3>
          <button className={css.closeBtn} onClick={onClose}>
            <X02 color={colors.primaryColor} width={12} height={12} />
          </button>
        </div>
        <div className={css.modalBody}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};

export default Modal;
